













import { IRouteCity, IRouteInfo } from "@/@types/routeInfo/route-info";
import { Component, Prop, Vue } from "vue-property-decorator";
import ChangeRouteForm from "@/components/forms/route_info/change-route-form.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: { ChangeRouteForm, ButtonBack },
})
export default class AddRoute extends Vue {
  @Prop({ type: Array, default: () => [] }) routeList!: Array<IRouteInfo>;
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;
  @Prop({ type: String, default: "" }) id!: string;

  route: IRouteInfo | null = null;
  show = false;

  onSubmitRoute(changed: IRouteInfo): void {
    let data: any = {};
    if (this.id) {
      const route = this.routeList.find((el) => el._id == this.id);
      if (!route) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
        return;
      }
      for (const key of Object.keys(changed)) {
        if (
          route[key as keyof IRouteInfo] != changed[key as keyof IRouteInfo] &&
          changed[key as keyof IRouteInfo] != undefined
        )
          data[key] = changed[key as keyof IRouteInfo];
      }
    } else data = changed;
    this.$emit("changeRoute", this.id, data);
    this.$router.push({ name: "RouteList" });
  }

  mounted(): void {
    if (this.id) {
      const route = this.routeList.find((el) => el._id == this.id);
      if (route) this.route = Object.assign({}, route);
    }
    this.show = true;
  }
}
